module.exports = __webpack_public_path__ + "img/illuminance.402a4729.svg";